module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": "Mine indstillinger"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toggle_show_beta_content
    }
  }, [(_vm.show_beta_content) ? [_vm._v("● beta-indhold")] : [_vm._v("○ beta-indhold")]], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toggle_show_debug_data_boxes
    }
  }, [(_vm.show_debug_data_boxes) ? [_vm._v("● dev debug boxes")] : [_vm._v("○ dev debug boxes")]], 2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Skift theme")]), _vm._v(" "), _vm._l((_vm.themes), function(theme, theme_key) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.apply_ui_theme(theme_key)
        }
      }
    }, [_vm._v(_vm._s(theme_key))]), _vm._v(" "), _c('br')]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goto('/tema-editor')
      }
    }
  }, [_vm._v("Tema editor")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goto('/kitchensink')
      }
    }
  }, [_vm._v("Kitchensink")])], 2), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Tips & tricks"
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("> Tags kan defineres på projekter eller kunde, under instillinger.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Projekter tagget 'fakturaklar' markeres klar til fakturering på hjemmeskærmen.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Projekter tagget med ens initialer (det før @ i ens Milk mail, f.eks. 'an') vises på ens hjemmeskærm så længe de ikke er afsluttede.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Man kan skifte theme ovenfor, eller selv definere ens egne ønskede farver.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Beta indhold kan vises/skjules ved klik på knappen ovenfor.")])])])])]), _vm._v(" "), (_vm.debug_output) ? _c('box', {
    attrs: {
      "label": "debug_output"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.debug_output))])]) : _vm._e(), _vm._v(" "), (_vm.is_user('wp')) ? _c('box', {
    attrs: {
      "label": "WP playground"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608515be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mysettings.vue
// module id = 605
// module chunks = 1